var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSnsFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#E9ECFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0922 13.1958V12.072C17.0797 11.9855 17.0877 11.8974 17.1156 11.8142C17.1435 11.7309 17.1906 11.6544 17.2536 11.5902C17.3166 11.526 17.3938 11.4756 17.4799 11.4427C17.5659 11.4098 17.6586 11.3952 17.7514 11.3999H19.4274V9H17.1201C14.5615 9 13.9804 10.7907 13.9804 11.9407V13.2063H12.5V15.9842H14.0084V23H16.9916V15.9842H19.2263L19.5 13.18L17.0922 13.1958Z",
    fill: "#415EA3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnsFacebook);
export default __webpack_public_path__ + "static/media/sns_facebook.5f34f86fe27b8cccd472cefb3232aa6e.svg";
export { ForwardRef as ReactComponent };